'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeList = makeList;
exports.makeMap = makeMap;
exports.default = clone;

var _immutable = require('immutable'); // https://github.com/facebook/immutable-js/blob/master/src/List.js#L381


function makeList() {
  var origin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var capacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;
  var root = arguments[3];
  var tail = arguments[4];
  var ownerID = arguments[5];
  var hash = arguments[6];
  var list = Object.create(_immutable.List.prototype);
  list.size = capacity - origin;
  list._origin = origin;
  list._capacity = capacity;
  list._level = level;
  list._root = root;
  list._tail = tail;
  list.__ownerID = ownerID;
  list.__hash = hash;
  list.__altered = false;
  return list;
} // https://github.com/facebook/immutable-js/blob/master/src/Map.js#L689


function makeMap() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var root = arguments[1];
  var ownerID = arguments[2];
  var hash = arguments[3];
  var map = Object.create(_immutable.Map.prototype);
  map.size = size;
  map._root = root;
  map.__ownerID = ownerID;
  map.__hash = hash;
  map.__altered = false;
  return map;
}

function clone(type) {
  return type === _immutable.List ? makeList() : makeMap();
}